import './style.scss'

document.addEventListener('DOMContentLoaded', ()=> {
  const containers = document.querySelectorAll('.sw-table__cell-scroll-container');

  containers.forEach(container => {
    const content = container.querySelector('.sw-table__cell-scroll-content');
    const shadowStart = container.querySelector('.sw-table__cell-scroll-shadow--start');
    const shadowEnd = container.querySelector('.sw-table__cell-scroll-shadow--end');
    const scrollGap = 8

    content.addEventListener('scroll', function () {
      if (content.offsetWidth + content.scrollLeft >= content.scrollWidth - scrollGap) {
        shadowEnd.classList.add('sw-table__cell-scroll-shadow--hidden');
      } else {
        shadowEnd.classList.remove('sw-table__cell-scroll-shadow--hidden');
      }

      if (content.scrollLeft > scrollGap) {
        shadowStart.classList.remove('sw-table__cell-scroll-shadow--hidden');
      } else {
        shadowStart.classList.add('sw-table__cell-scroll-shadow--hidden');
      }
    });
  });
})
